import { OutDebt } from '../generated/graphql';

export const getJcapInterests = ({ extra }: OutDebt) => {
  const {
    extraAccountingInterests = 0,
    currentInterests = 0,
    defaultInterests = 0,
    otherCharges = 0,
  } = extra || {};
  return (
    (extraAccountingInterests ?? 0)
    + (currentInterests ?? 0)
    + (defaultInterests ?? 0)
    + (otherCharges ?? 0)
  );
};
